<template>
  <div class="w-fit flex flex-col">
    <div class="flex flex-wrap gap-x-6 gap-y-2">
      <label
        v-for="(option, index) in optionsList"
        :key="option.value"
        :for="uid + '_' + index"
        class="flex cursor-pointer items-center gap-2 select-none"
      >
        <input
          :id="uid + '_' + index"
          v-model="localSelection"
          type="radio"
          :value="option.value"
          :required="required"
          class="peer sr-only"
        />
        <span
          class="flex h-5 w-5 shrink-0 items-center justify-center rounded-full border-2 border-blue-500 transition-colors after:content-[''] after:h-3 after:w-3 after:rounded-full after:bg-transparent after:transition-colors peer-checked:after:bg-primary-2"
        />
        <span class="text-sm">{{ option.name }}</span>
      </label>
    </div>
    <div
      v-if="isError"
      class="mt-2 text-xs text-yellow-600 dark:text-yellow-600 border-t"
    >
      <template v-for="error in validation?.$silentErrors" :key="error">
        {{ error.$message }}
      </template>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, useId } from 'vue';
import { RadioOption } from '@/enums/radiator/generic';
import { Validation } from '@vuelidate/core';

const props = defineProps<{
  optionsList: ReadonlyArray<RadioOption>;
  selection: any;
  required?: boolean;
  validation?: Validation;
}>();

const emit = defineEmits(['update:selection']);

const uid = useId();

const localSelection = computed({
  get() {
    return props.selection;
  },
  set(value) {
    props.validation?.$touch();
    emit('update:selection', value);
  },
});

const isError = computed(() => {
  if (props.validation) {
    return props.validation?.$errors?.length > 0 && props.validation?.$dirty;
  }
  return false;
});
</script>
